module.exports = __webpack_public_path__ + "static/media/12UNCTAD1.8683a937.jpg";